module.exports = __webpack_public_path__ + "img/office3.a5fc75bf.jpg";